(() => {
  'use strict';
  if (window.BPLaunch) return;
  const node = document.getElementById('bp-launch-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const instant = value => typeof value === 'string' && /(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
  const open = instant(config.openAt), start = instant(config.startAt), end = instant(config.endAt);
  const valid = Number.isFinite(open) && Number.isFinite(start) && Number.isFinite(end) && start < end;
  const role = window.Shopify?.theme?.role;
  config.preview = role !== 'main' && role !== 'live' &&
    (role === 'unpublished' || role === 'development' || config.designMode === true);
  const simulated = config.preview ? instant(new URLSearchParams(location.search).get('bp_now')) : NaN;
  let epoch = Number(config.serverNow) || Date.now();
  let anchor = performance.now();
  let source = 'liquid';
  let timer, syncing = null, initialized = false;
  const listeners = new Set();
  const now = () => epoch + performance.now() - anchor;
  const state = () => {
    const time = now();
    return { now: time, active: valid && time >= start && time < end, ended: valid && time >= end,
      before: valid && time < start, valid, synchronized: initialized, source, simulated: Number.isFinite(simulated) };
  };
  const emit = () => {
    const detail = state();
    listeners.forEach(fn => { try { fn(detail); } catch (error) { console.error('BP launch subscriber', error); } });
    document.dispatchEvent(new CustomEvent('bp:launch:tick', { detail }));
  };
  const tick = () => {
    clearTimeout(timer);
    if (document.hidden) return;
    emit();
    timer = setTimeout(tick, 1000 - (now() % 1000) + 5);
  };
  const sync = () => {
    if (syncing) return syncing;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6000);
    const sent = performance.now();
    syncing = fetch(location.href.split('#')[0], { method: 'HEAD', cache: 'no-store', credentials: 'same-origin', signal: controller.signal })
      .then(response => {
        const server = Date.parse(response.headers.get('Date'));
        if (response.ok && Number.isFinite(server) && !Number.isFinite(simulated)) {
          epoch = server + (performance.now() - sent) / 2;
          anchor = performance.now();
          source = 'server-date';
        }
      }).catch(() => {}).finally(() => {
        clearTimeout(timeout);
        syncing = null;
        initialized = true;
        tick();
      });
    return syncing;
  };
  if (Number.isFinite(simulated)) {
    epoch = simulated;
    anchor = performance.now();
    source = 'preview';
  }
  const api = { config: Object.freeze(config), now, state, ready: null,
    subscribe(fn) { listeners.add(fn); if (initialized) fn(state()); return () => listeners.delete(fn); },
    resync: sync };
  window.BPLaunch = api;
  api.ready = sync().then(() => api);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) clearTimeout(timer);
    else sync();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) sync(); });
  document.addEventListener('shopify:section:load', () => { if (initialized) emit(); });
})();
